import { render, staticRenderFns } from "./WaitingTehBookingStep.vue?vue&type=template&id=18dd1070&scoped=true"
import script from "./WaitingTehBookingStep.vue?vue&type=script&lang=js"
export * from "./WaitingTehBookingStep.vue?vue&type=script&lang=js"
import style0 from "./WaitingTehBookingStep.vue?vue&type=style&index=0&id=18dd1070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd1070",
  null
  
)

export default component.exports